(function() {

  var linkFunction = function($scope, element, attrs) {
    // console.log("Billing Address Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function($scope, $rootScope) {
    $scope.states = $rootScope.states;
    $scope.editMode = $scope.card && $scope.card.paymentMethodId ? true : false;
    $scope.wcmContent = wcmContent;

    if($scope.editMode){
      $scope.addressLine1 = $scope.address.addressLine1;
      $scope.addressLine2 = $scope.address.addressLine2;
      $scope.state = $scope.address.state;
      $scope.city = $scope.address.city;
      $scope.zipCode = $scope.address.zipCode;
    }

    $scope.onKeyUp = function(){
      if($('#address-city').val().length > 50){
          $('#address-city').val($('#address-city').val().substr(0, 50));
      }

    }

  }

  var directiveFunction = function() {
    return {
      restrict: 'E',
      scope: {
        editable: "=",
        address: "=",
        card: "="
      },
      templateUrl: '../payments/app/components/billingAddress/billingAddress.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }


  controllerFunction.$inject = ["$scope", "$rootScope"];
  angular.module('cvsApp').directive('billingAddress', directiveFunction);

})();
